<modal-layout-right modalTitle="Added to basket"
  [smallText]="true">

  <div modalBody
    cy-minibasketView>

    @if (basket.qty) {
      <div>
        <basket-free-shipping class="block m-b-8"></basket-free-shipping>
        @for (item of basket.items; track itemTrackFn($index, item); let last = $last; let first = $first) {
          <basket-view-item class="block p-b"
            [class.m-t]="!first"
            [class.b-b]="!last"
            [item]="item"
          cy-minibasketItem></basket-view-item>
        }
      </div>
    }
    @if (!basket.qty) {
      <div cy-basketEmpty
        class="center p2 col-1"
        translate>
        Your basket is empty
      </div>
    }

  </div>

  @if (basket.qty) {
    <div modalFooter
      >
      <basket-view-totals class="block m-t-5 m-t-9-s m-t-9-m"></basket-view-totals>
      <basket-view-submit class="block m-t"
        [basketAddConfirmationText]="true"
      [link]="'/basket'"></basket-view-submit>
      <a (click)="close()"
        class="w-12 m-t-2 button-1">
        Continue shopping
      </a>
    </div>
  }

</modal-layout-right>